import { message } from 'antd';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, Grid, Icon, Row } from 'rsuite';
import styled from 'styled-components';

import { PanelContent, PanelWhite } from '../../../components/Layout/styles';
import { ToastVariant } from '../../../components/Toast/toast.model';
import { toastService } from '../../../components/Toast/toast.service';
import { firebaseFunctions } from '../../../firebase/firebase';
import { FirebaseCallableFunctions } from '../../../firebase/firebase.models';
import { copyTextToClipboard } from '../../../utils/navigator.utils';
import { useAuth } from '../../Auth/AuthContext';

const StyledButton = styled(Button)`
  & > * {
    margin-right: ${({ theme }) => theme.gap(2)};
  }
`;

interface Props {
  id: string;
}
export const OfferMainButtons: React.FC<Props> = ({ id }) => {
  const { currentUser } = useAuth();
  const { t } = useTranslation();
  const [color, setColor] = useState('orange');
  const [isLoading, setIsLoading] = useState(false);

  const onShare = () => {
    copyTextToClipboard(
      window.location.href,
      () => {
        message.success(t('OFFER_MAIN_BUTTONS.LINK_COPIED'));
      },
      () => {
        message.error(t('OFFER_MAIN_BUTTONS.LINK_COPY_FAILED'));
      }
    );
  };
  const onAddToFavorites = useCallback(() => {
    if (isLoading) return;
    setIsLoading(true);

    const addToFavorites = firebaseFunctions.httpsCallable(FirebaseCallableFunctions.ADD_TO_FAVORITES);
    addToFavorites({ offerId: id, uid: currentUser.uid })
      .then(() => {
        toastService.show(t('OFFER.FAVORITE_ADDED_DESC'), t('OFFER.FAVORITE_ADDED'));
        setIsLoading(false);
        setColor('grey');
      })
      .catch(() => {
        toastService.show(t('OFFER.ADD_TO_FAVORITE_ERROR'), t('OFFER.ERROR'), { variant: ToastVariant.ERROR });
        setIsLoading(false);
      });
  }, [isLoading, currentUser, id]);

  return (
    <PanelWhite bodyFill>
      <PanelContent>
        <Grid fluid>
          <Row gutter={16}>
            <Col xs={12}>
              <StyledButton color="yellow" size={'lg'} block onClick={onShare}>
                <Icon icon={'share-square-o'} size={'lg'} />
                {t('OFFER_MAIN_BUTTONS.SHARE')}
              </StyledButton>
            </Col>
            <Col xs={12}>
              <StyledButton onClick={onAddToFavorites} loading={isLoading} color={color} size={'lg'} block>
                <Icon icon={'heart-o'} size={'lg'} />
                {t('OFFER_MAIN_BUTTONS.ADD_TO_FAV')}
              </StyledButton>
            </Col>
          </Row>
        </Grid>
      </PanelContent>
    </PanelWhite>
  );
};
